import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

interface Props {
  title: string;
  defaultOpen?: boolean;
  // Texto sutil a la derecha del header (ej. "3 campos", "con contenido").
  meta?: string;
  children: React.ReactNode;
}

// Sección colapsable animada para agrupar campos del editor. Divulgación
// progresiva: por defecto solo la primera sección abierta. Tokens ui-*.
export function CollapsibleSection({ title, defaultOpen = false, meta, children }: Props) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="border-b border-ui-border last:border-b-0">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between py-3 text-left group"
      >
        <span className="flex items-center gap-2">
          <motion.span
            animate={{ rotate: open ? 0 : -90 }}
            transition={{ duration: 0.18 }}
            className="text-ui-text-subtle group-hover:text-ui-text-muted"
          >
            <ChevronDown size={15} />
          </motion.span>
          <span className="text-xs font-semibold uppercase tracking-wider text-ui-text-subtle group-hover:text-ui-text-muted transition-colors">
            {title}
          </span>
        </span>
        {meta && <span className="text-xs text-ui-text-subtle">{meta}</span>}
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.22, ease: 'easeInOut' }}
            className="overflow-hidden"
          >
            <div className="space-y-4 pb-4 pt-1">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
